export const Filter = {
  CustomerName: "customerName" as const,
  OrgNumber: "orgNumber" as const,
  Rating: "rating" as const,
  Date: "date" as const,
  NumOfInvoices: "numOfInvoices" as const,
  InvoicedAmount: "invoicedAmount" as const,
  UnpaidAmount: "unpaidAmount" as const,
  NumOfRecurringInvoices: "numOfRecurringInvoices" as const,
  Active: "active" as const,
}

export const Create = {
  Id: "id" as const,
  AlreadyExists: "alreadyExists" as const,
  GeneralInfo: "generalInfo" as const,
  FromRegistry: "fromRegistry" as const,
  RutRotSettings: "rutRotSettings" as const,
  OtherDetailsSettings: "otherDetailsSettings" as const,
  PaymentSettings: "paymentSettings" as const,
  DisplaySettings: "displaySettings" as const,
  SendOptions: "sendOptions" as const,
  ReminderSettings: "reminderSettings" as const,
}

export const GeneralInfo = {
  Name: "name" as const,
  OrgNumber: "orgNumber" as const,
  Emails: "emails" as const,
  PhoneNumber: "phoneNumber" as const,
  ReferencePersons: "referencePersons" as const,
  BillingAddress: "billingAddress" as const,
  DeliveryAddress: "deliveryAddress" as const,
  IsSameDeliveryAddress: "isSameDeliveryAddress" as const,
  Active: "active" as const,
}

export const Address = {
  Street1: "street1" as const,
  Street2: "street2" as const,
  City: "city" as const,
  ZipCode: "zipCode" as const,
  CountryCode: "countryCode" as const,
}

export const ReferencePerson = {
  CustomerId: "customerId" as const,
  Id: "id" as const,
  Name: "name" as const,
  Email: "email" as const,
  EmailSplit: "emailSplit" as const,
  PhoneNumber: "phoneNumber" as const,
  ReferenceId: "referenceId" as const,
  IsDefault: "isDefault" as const,
  IsEInvoicesEnabled: "isEInvoicesEnabled" as const,
}

export const RutRotSettings = {
  PropertyDesignation: "propertyDesignation" as const,
  TenantsOwnerAssociationOrgNumber: "tenantsOwnerAssociationOrgNumber" as const,
  ApartmentNumber: "apartmentNumber" as const,
}

export const OtherDetailsSettings = {
  GlnNumber: "glnNumber" as const,
  VatNumber: "vatNumber" as const,
  IncludeVATNumber: "includeVATNumber" as const,
}

export const PaymentSettings = {
  PaymentTerms: "paymentTerms" as const,
  IsAutogiro: "isAutogiro" as const,
  AutogiroPayerNumber: "autogiroPayerNumber" as const,
}

export const DisplaySettings = {
  Language: "language" as const,
  ShowCurrencyCode: "showCurrencyCode" as const,
}

export const InvoiceSendOptions = {
  SettingType: "settingType" as const,
  InvoiceSendType: "invoiceSendType" as const,
  InvoiceTitleTemplate: "invoiceTitleTemplate" as const,
  InvoiceMessageTemplate: "invoiceMessageTemplate" as const,
  InvoiceFileNameTemplate: "invoiceFileNameTemplate" as const,
  InvoiceSendTo: "invoiceSendTo" as const,
  InvoiceSendToEmail: "invoiceSendToEmail" as const,
  InvoiceNotesTemplate: "invoiceNotesTemplate" as const,
}

export const ReminderSettings = {
  SettingType: "settingType" as const,
  ReminderCost: "reminderCost" as const,
  PenaltyInterestType: "penaltyInterestType" as const,
  PenaltyInterestPercentage: "penaltyInterestPercentage" as const,
  IsAutomaticRemindersEnabled: "isAutomaticRemindersEnabled" as const,
  AutomaticReminderAmountLimit: "automaticReminderAmountLimit" as const,
  AutomaticReminderDelay: "automaticReminderDelay" as const,
  AutomaticReminderPeriod: "automaticReminderPeriod" as const,
  AutomaticReminderCountLimit: "automaticReminderCountLimit" as const,
  InvoiceReminderNotesTemplate: "invoiceReminderNotesTemplate" as const,
  ReminderSendType: "reminderSendType" as const,
  InvoiceReminderTitleTemplate: "invoiceReminderTitleTemplate" as const,
  InvoiceReminderMessageTemplate: "invoiceReminderMessageTemplate" as const,
  InvoiceReminderFileNameTemplate: "invoiceReminderFileNameTemplate" as const,
  InvoiceReminderSendTo: "invoiceReminderSendTo" as const,
  InvoiceReminderSendToEmail: "invoiceReminderSendToEmail" as const,
}

export const CustomerImport = {
  CsvUpload: "csvUpload" as const,
  Delimiter: "delimiter" as const,
  CustomerNameColumn: "customerNameColumn" as const,
  OrgNrColumn: "orgNrColumn" as const,
  EmailAddressColumn: "emailAddressColumn" as const,
  PhoneNumberColumn: "phoneNumberColumn" as const,
  BillingStreetColumn: "billingStreetColumn" as const,
  BillingStreet2Column: "billingStreet2Column" as const,
  BillingZipCodeColumn: "billingZipCodeColumn" as const,
  BillingCityColumn: "billingCityColumn" as const,
  BillingCountryCodeColumn: "billingCountryCodeColumn" as const,
  DeliveryStreetColumn: "deliveryStreetColumn" as const,
  DeliveryStreet2Column: "deliveryStreet2Column" as const,
  DeliveryZipCodeColumn: "deliveryZipCodeColumn" as const,
  DeliveryCityColumn: "deliveryCityColumn" as const,
  DeliveryCountryCodeColumn: "deliveryCountryCodeColumn" as const,
  VatNumberColumn: "vatNumberColumn" as const,
  GlnNumberColumn: "glnNumberColumn" as const,
  IncludeVatNumberOnInvoiceColumn: "includeVatNumberOnInvoiceColumn" as const,
  CustomerStandardPaymentTermsColumn: "customerStandardPaymentTermsColumn" as const,
  ShowCurrencyCodeColumn: "showCurrencyCodeColumn" as const,
  LanguageColumn: "languageColumn" as const,
  ReferencePersons: "referencePersons" as const,
  PropertyDesignationColumn: "propertyDesignationColumn" as const,
  TenantsOwnerAssociationOrgNumberColumn: "tenantsOwnerAssociationOrgNumberColumn" as const,
  ApartmentNumberColumn: "apartmentNumberColumn" as const,
}

export const ReferencePersonImport = {
  Id: "id" as const,
  NameColumn: "nameColumn" as const,
  MailColumn: "mailColumn" as const,
  PhoneColumn: "phoneColumn" as const,
  IdentifierColumn: "identifierColumn" as const,
  IsDefaultColumn: "isDefaultColumn" as const,
}

